exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".commonicdchangesbydrg{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/reports/commonicdchangesbydrg/commonicdchangesbydrg.styl
// module id = 71
// module chunks = 1